__turbopack_context__.v({
  "assistantMessage": "Assistant-module__3Takcq__assistantMessage",
  "assistantTurn": "Assistant-module__3Takcq__assistantTurn",
  "card": "Assistant-module__3Takcq__card",
  "cardBody": "Assistant-module__3Takcq__cardBody",
  "cardChevron": "Assistant-module__3Takcq__cardChevron",
  "cardDiscount": "Assistant-module__3Takcq__cardDiscount",
  "cardThumb": "Assistant-module__3Takcq__cardThumb",
  "cardTitle": "Assistant-module__3Takcq__cardTitle",
  "cards": "Assistant-module__3Takcq__cards",
  "cardsMore": "Assistant-module__3Takcq__cardsMore",
  "cartUpdated": "Assistant-module__3Takcq__cartUpdated",
  "composer": "Assistant-module__3Takcq__composer",
  "footer": "Assistant-module__3Takcq__footer",
  "header": "Assistant-module__3Takcq__header",
  "headerIcon": "Assistant-module__3Takcq__headerIcon",
  "headerText": "Assistant-module__3Takcq__headerText",
  "iconButton": "Assistant-module__3Takcq__iconButton",
  "input": "Assistant-module__3Takcq__input",
  "launcher": "Assistant-module__3Takcq__launcher",
  "launcherLabel": "Assistant-module__3Takcq__launcherLabel",
  "messages": "Assistant-module__3Takcq__messages",
  "notice": "Assistant-module__3Takcq__notice",
  "pageOpened": "Assistant-module__3Takcq__pageOpened",
  "panel": "Assistant-module__3Takcq__panel",
  "sendButton": "Assistant-module__3Takcq__sendButton",
  "suggestion": "Assistant-module__3Takcq__suggestion",
  "suggestions": "Assistant-module__3Takcq__suggestions",
  "textButton": "Assistant-module__3Takcq__textButton",
  "userMessage": "Assistant-module__3Takcq__userMessage",
  "working": "Assistant-module__3Takcq__working",
});
